import { WebhookMilestonesFlexportTableRow } from './interfaces/WebhookMilestonesFlexportTableRow.interfaces'

export const MILESTONES_FLEXPORT_DEFAULT: WebhookMilestonesFlexportTableRow[] = [
  //#region Estimated Transit Events
  {
    type: '/shipment#schedule_confirmed',
    description: 'Estimated departure and arrival dates set for each specified location.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment_leg#updated_estimated_time_of_departure',
    description: 'Revised estimate of date when shipment will depart from specified location.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment_leg#updated_estimated_time_of_arrival',
    description: 'Revised estimate of date when shipment will arrive at specified location.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment_leg#updated_estimated_out_for_delivery',
    description: 'Revised estimate of date when shipment is out for delivery.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#updated_route',
    description: 'Updated route to final destination, such as changes to intermediary locations or ports.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment_container_leg#updated_estimated_available_for_pickup',
    description: 'Revised estimated of date when shipment will be ready for pickup at the port of delivery.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  //#region Actual Transit Events
  {
    type: '/shipment_leg#arrived',
    description: 'Shipment arrived at specified location.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment_leg#departed',
    description: 'Shipment departed from specified location.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment_leg#out_for_delivery',
    description: 'Shipment departed and is out for delivery.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment_leg#delivery_completed',
    description: 'Shipment delivery is complete.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/ocean/shipment_container_leg#loaded_on_board',
    description: 'Shipment container loaded on vessel or rail.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/ocean/shipment_leg#loaded_on_truck',
    description: 'Cargo has been transloaded from shipment container to truck.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/ocean/shipment_container_leg#unloaded_off_board',
    description: 'Shipment container discharged from vessel or rail.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment_leg#delivered',
    description: 'Part of a shipment delivered to final destination.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#delivered_in_full',
    description: 'Entire shipment delivered to final destination, e.g. multi-container shipments.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  //#region Administrative Events
  {
    type: '/shipment#created',
    description: 'User has confirmed Flexport quote and cargo is getting ready to ship.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#booking_confirmed',
    description: 'Shipment is booked with the air carrier.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cargo_ready_date_changed',
    description: 'Cargo ready date changed from the original cargo ready date.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#documents_sent_to_nominated_broker',
    description: 'Arrival notice sent to client-nominated customs broker. Applicable to non-Flexport customs service shipments only.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipments#commercial_invoices_digitized',
    description: 'All commercial invoices have been entered into the Flexport system.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/ocean/shipment_container_leg#available_for_pickup',
    description: 'Container becomes available for pickup from port.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment_leg#delivery_appointment_requested',
    description: 'Date the delivery appointment was requested.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment_leg#delivery_appointment_scheduled',
    description: 'Date of the scheduled delivery appointment.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#filing_submitted_for_in_bond_transportation',
    description: 'Date when the filing was submitted.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/ocean/shipment_container#free_time_to_expire',
    description: 'Date when container free time expires.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/ocean/shipment_container#free_time_expired',
    description: 'Date when container free time expired.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#ftz_admission',
    description: 'Date when carrier is informed that the posted bill has been placed on a FTZ admission.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/ocean/shipment_container#empty_returned',
    description: 'Empty container returned to carrier.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#flight_delay_mechanical',
    description: 'Delay due to mechanical issue with the airplane.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#flight_delay_schedule_updated_by_carrier',
    description: 'Delay due to a flight schedule change made by the carrier.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#late_bill_of_lading_release',
    description: 'Delay due to late bill of lading release.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#missed_appointment',
    description: 'Delivery not completed due to missed appointment.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#ocean_port_dwell_delay',
    description: 'Delay due to dwell at ocean port.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#port_strike_delay',
    description: 'Delay due to port strike.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#vessel_delay_mechanical',
    description: 'Delay due to mechanical issue with the vessel.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#warehouse_devan_delay',
    description: 'Delay due to warehouse devan.',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_deconsolidation_wh_schedule_delay_trucking_pending_linehaul_consolidation',
    description: '(Deconsolidation WH) Schedule delay: Trucking - Pending Linehaul Consolidation',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_destination_port_dwell_schedule_delay_client_pending_consignee_pickup',
    description: '(Destination Port Dwell) Schedule delay: Client - Pending Consignee Pickup',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_destination_port_dwell_schedule_delay_customs_customs_exam',
    description: '(Destination Port Dwell) Schedule delay: Customs - Customs Exam',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_destination_port_dwell_schedule_delay_force_majeure_weather_delay',
    description: '(Destination Port Dwell) Schedule delay: Force Majeure - Weather Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_destination_port_dwell_schedule_delay_trucking_mechanical_problem',
    description: '(Destination Port Dwell) Schedule delay: Trucking - Mechanical Problem',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_destination_port_dwell_schedule_delay_trucking_operational_mistake_by_trucker',
    description: '(Destination Port Dwell) Schedule delay: Trucking - Operational mistake by trucker',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_destination_port_dwell_schedule_delay_unavailable_container_damaged',
    description: '(Destination Port Dwell) Schedule delay: Unavailable - Container Damaged',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_destination_port_dwell_schedule_delay_unavailable_container_physically_inaccessible_for_pickup',
    description: '(Destination Port Dwell) Schedule delay: Unavailable - Container physically inaccessible for pickup',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_destination_port_dwell_schedule_delay_unavailable_no_pickup_appointments_available',
    description: '(Destination Port Dwell) Schedule delay: Unavailable - No Pickup Appointments Available',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_destination_port_dwell_schedule_delay_unavailable_unable_to_locate',
    description: '(Destination Port Dwell) Schedule delay: Unavailable - Unable to Locate',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_lcl_consolidation_schedule_delay_client_unable_to_load_on_vessel_due_to_shipper_or_client_delay',
    description: '(LCL Consolidation) Schedule delay: Client - Unable to load on vessel due to shipper or client delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_network_final_delivery_schedule_delay_client_warehouse_rescheduled',
    description: '(Network Final Delivery) Schedule delay: Client - Warehouse Rescheduled',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_ocean_final_delivery_schedule_delay_client_delivery_location_changed',
    description: '(Ocean Final Delivery) Schedule delay: Client - Delivery Location Changed',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_ocean_final_delivery_schedule_delay_customs_customs_exam',
    description: '(Ocean Final Delivery) Schedule delay: Customs - Customs Exam',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_ocean_final_delivery_schedule_delay_operator_mistake_flexgo',
    description: '(Ocean Final Delivery) Schedule delay: Operator Mistake - flexGO',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_ocean_final_delivery_schedule_delay_trucking_operational_mistake_by_trucker',
    description: '(Ocean Final Delivery) Schedule delay: Trucking - Operational mistake by trucker',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_ocean_origin_pickup_schedule_delay_client_early_pickup_request',
    description: '(Ocean Origin Pickup) Schedule delay: Client - Early pickup/storage request',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_ocean_origin_pickup_schedule_delay_other_please_leave_detailed_reasons_in_notes',
    description: '(Ocean Origin Pickup) Schedule delay: Other - Please leave detailed reasons in notes',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_ocean_origin_pickup_schedule_delay_trucking_operational_mistake_by_trucker',
    description: '(Ocean Origin Pickup) Schedule delay: Trucking - Operational mistake by trucker',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_origin_port_dwell_schedule_delay_carrier_change_of_vessel_due_to_port_omit',
    description: '(Origin Port Dwell) Schedule delay: Carrier - Change of vessel due to Port Omit',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_origin_port_dwell_schedule_delay_carrier_delay_in_vessel_departure',
    description: '(Origin Port Dwell) Schedule delay: Carrier - Delay in vessel departure',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_origin_port_dwell_schedule_delay_client_request_to_hold_shipment_at_origin',
    description: '(Origin Port Dwell) Schedule delay: Client - Request to hold shipment at origin',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_origin_port_dwell_schedule_delay_client_unable_to_load_on_vessel_due_to_shipper_or_client_delay',
    description: '(Origin Port Dwell) Schedule delay: Client - Unable to load on vessel due to shipper or client delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_origin_port_dwell_schedule_delay_operator_mistake',
    description: '(Origin Port Dwell) Schedule delay: Operator Mistake',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#_origin_port_dwell_schedule_delay_trucking_operational_mistake_by_trucker',
    description: '(Origin Port Dwell) Schedule delay: Trucking - Operational mistake by trucker',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#all_documents_received_from_shipper',
    description: 'FID 63495 - All Documents Received from Shipper',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#booking_request_and_shipper_documents_mismatch',
    description: 'FID 63495 - Booking Request and Shipper Documents Mismatch',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cargo_breakdown_delay',
    description: 'Cargo Breakdown Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cargo_bumped_from_booked_flight',
    description: 'Cargo Bumped From Booked Flight',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cargo_contamination_delay',
    description: 'Cargo Contamination Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cargo_declaration_mismatch',
    description: 'Cargo Declaration Mismatch',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cargo_not_available',
    description: 'Cargo Not Available',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cargo_ready_date_changed_exception',
    description: 'Cargo Ready Date Changed',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cargo_ready_date_unconfirmed',
    description: 'Cargo Ready Date Unknown',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cargo_received_after_cutoff',
    description: 'FID 63495 - Cargo Received After Cutoff',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cargo_rolled_from_booked_vessel',
    description: 'Cargo Rolled from Booked Vessel',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#carrier_refused_bumped_dg_shipment',
    description: 'Carrier Refused/Bumped DG Shipment',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#congestion_at_transit_port',
    description: 'Flight Delay: Congestion at Transit Port',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#consignee_related_house_bill_of_lading_release_delay',
    description: 'Consignee related House Bill of Lading release delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#container_carrier_hold',
    description: 'Carrier Freight Hold',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#container_customs_hold',
    description: 'Container Hold: Customs',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#container_discharge_delay',
    description: 'Discharge Delay at Rail Yard',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#container_hold_other',
    description: 'Container Hold: Other',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cpsc_hold',
    description: 'Shipment Under Consumer Product Safety Commission (CPSC) Review - Hold Cargo Intact',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#cpsc_hold_removed',
    description: 'CPSC Hold Removed',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#customs_agriculture_hold',
    description: 'Shipment Under Customs Agricultural Hold - Hold Cargo Intact',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#customs_agriculture_hold_exam',
    description: 'Shipment Under Customs Agricultural Exam - Hold Cargo Intact',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#customs_agriculture_hold_removed',
    description: 'Customs Agriculture Hold Removed',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#customs_entry_release_status_pending_intensive_exam',
    description: 'Release Status Change: Pending Intensive Exam',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#customs_entry_release_status_released',
    description: 'Customs entry released',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#customs_hold_contains_goods_with_export_restrictions',
    description: 'FID 63495 - Customs Hold: Contains Goods with Export Restrictions',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#delivery_appointment_confirmed',
    description: 'Delivery Appointment Confirmed',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#delivery_appointment_updated',
    description: 'Delivery Appointment Updated',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#delivery_cancelled_wrong_delivery_address',
    description: 'Delivery Cancelled: Wrong Delivery Address',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#delivery_delay',
    description: 'FID 63495 - Delivery Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#delivery_location_not_accessible',
    description: 'FID 63495 - Delivery Location Not Accessible',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#demurrage_storage_incurred',
    description: 'Demurrage (Storage) Incurred',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#discharge_delay_at_ocean_port',
    description: 'Discharge Delay at Ocean Port',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#dry_run_delivery_attempt_not_completed',
    description: 'Dry Run: Delivery Attempt Not Completed',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#dry_run_delivery_location_closed',
    description: 'Dry Run: Delivery Location Closed',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#dry_run_delivery_refused_by_consignee',
    description: 'Dry Run: Delivery Refused by Consignee',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#dry_run_improper_equipment_for_delivery',
    description: 'FID 63495 - Dry Run: Improper Equipment for Delivery',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#dry_run_pickup',
    description: 'Dry Run: Pick Up Not Completed',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#early_delivery_expected',
    description: 'Early Delivery Expected',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#emea_customs_hold_released',
    description: 'EMEA Customs Hold Released',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#emea_customs_inspection_released',
    description: 'EMEA Customs Inspection Released',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#empty_container_not_returned',
    description: 'Empty Container Not Returned',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#epa_exam_hold_intact',
    description: 'Shipment Under EPA Exam - Hold Cargo Intact',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#epa_may_proceed',
    description: 'EPA May Proceed (Released)',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#epa_review_under_review_hold_cargo_intact',
    description: 'Shipment Under EPA Review - Hold Cargo Intact',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#equipment_unavailable',
    description: 'Equipment Unavailable',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#eu_other_government_agency_oga_hold',
    description: 'EU Other Government Agency (OGA) Hold',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#export_country_customs_exam',
    description: 'Export Country Customs Exam',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#export_country_magnetism_exam',
    description: 'Export Country Magnetism Exam',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#export_customs_cleared',
    description: 'FID 63495 - Export Customs Cleared',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#export_customs_requested',
    description: 'FID 63495 - Export Customs Requested',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#fda_hold_hold_intact',
    description: 'Shipment Under FDA Hold - Hold Cargo Intact',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#fda_may_proceed',
    description: 'FDA May Proceed (Released)',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#fda_review_under_review_hold_cargo_intact',
    description: 'Shipment Under Standard FDA Review - Hold Cargo Intact (No Action Needed)',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#fid_63495_delay_at_unloading',
    description: 'FID 63495 - Delay at unloading',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#fid_63495_linehaul_arrival_late',
    description: 'FID 63495 - Linehaul arrival late',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#fid_63495_linehaul_departure_late',
    description: 'FID 63495 - Linehaul departure late',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#fid_63495_pick_up_delayed_due_to_late_assignment_by_tmc',
    description: 'FID 63495 - Pick-up delayed due to late assignment by TMC',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#fid_63495_root_cause_unknown',
    description: 'FID 63495 - Root cause unknown',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#fid_63495_technical_problems_at_lsp_at_hub_consolidation_point_',
    description: 'FID 63495 - Technical problems at LSP (at hub / consolidation point)',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#fish_and_wildlife_hold',
    description: 'Shipment Under Fish & Wildlife (FWS) Hold - Hold Cargo Intact',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#fish_and_wildlife_released',
    description: 'Fish & Wildlife (FWS) Released',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#flexport_booking_error',
    description: 'Flexport Booking Error',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#flexport_documentation_error',
    description: 'Flexport Documentation Error',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#flight_delay_mechanical',
    description: 'Flight Delay: Mechanical Problem',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#flight_delay_schedule_updated_by_carrier',
    description: 'Flight Delay: Schedule Updated by Carrier',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#goods_damaged',
    description: 'Goods Damaged',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#goods_damaged_at_service_center',
    description: 'FID 63495 - Goods Damaged at Service Center',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#goods_damaged_in_transit',
    description: 'FID 63495 - Goods Damaged in Transit',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#goods_lost_in_transit',
    description: 'FID 63495 - Goods Lost in Transit',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#goods_missing_in_transit',
    description: 'FID 63495 - Goods Missing in Transit',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#hold_cbp',
    description: 'US Customs Hold',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#incomplete_shipper_onboarding',
    description: 'Incomplete Shipper Onboarding',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#isf_not_on_file',
    description: 'ISF Not on File',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#lsp_prealert_issue',
    description: 'LSP Prealert Issue',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#manifest_hold_cbp',
    description: 'US Customs Manifest Hold',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#missed_appointment',
    description: 'Missed Appointment',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#missing_cargo',
    description: 'Missing Cargo at Final Destination',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#missing_consignee_commercial_invoice_packing_list',
    description: 'Missing Consignee Commercial Invoice/Packing List',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#missing_customs_documents',
    description: 'Missing Customs Documents',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#missing_dangerous_goods_dg_document',
    description: 'Missing Dangerous Goods (DG) Document',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#missing_proof_of_delivery_pod_',
    description: 'Missing Proof of Delivery (POD)',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#name_of_consignee_unclear',
    description: 'Name of Consignee Unclear',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#no_appointments_available',
    description: 'No Delivery Appointments Available',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#no_attempt_made',
    description: 'No Attempt Made',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#ocean_port_dwell_delay',
    description: 'Ocean Port Dwell Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#on_hand_at_destination_service_center',
    description: 'FID 63495 - On Hand at Destination Service Center',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#on_hand_at_hub_consolidation_center_destination',
    description: 'FID 63495 - On Hand at Hub/Consolidation Center Destination',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#on_hand_at_hub_consolidation_center_origin',
    description: 'FID 63495 - On Hand at Hub/Consolidation Center Origin',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#on_hand_at_origin_service_center',
    description: 'FID 63495 - On Hand at Origin Service Center',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#other_customs_exception',
    description: 'Other Customs Exception',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#packaging_issue',
    description: 'Packaging Issue',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#passed_oga_exam',
    description: 'Passed OGA exam',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#pending_customs_clearance_from_nominated_broker',
    description: 'Pending Customs Clearance from Nominated Broker',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#pending_delivery_appointment_confirmation',
    description: 'Pending Delivery Appointment Confirmation',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#pickup_cancelled_cargo_damaged',
    description: 'FID 63495 - Pickup Cancelled: Cargo Damaged',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#pickup_cancelled_no_pickup_possible',
    description: 'FID 63495 - Pickup Cancelled: No Pickup Possible',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#pickup_cancelled_wrong_pickup_address',
    description: 'FID 63495 - Pickup Cancelled: Wrong Pickup Address',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#pickup_delayed',
    description: 'FID 63495 - Pickup Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#port_strike_delay',
    description: 'Port Strike Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#rail_car_equipment_breakdown',
    description: 'Railcar Equipment Breakdown',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#rail_delay_schedule_updated_by_carrier',
    description: 'Rail Delay: Schedule Updated by Carrier',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#rail_interchange_delay',
    description: 'Rail Interchange Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#rail_transfer_delay',
    description: 'Rail Transfer Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#returned_to_shipper',
    description: 'FID 63495 - Cargo Returned to Shipper',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#security_delay',
    description: 'FID 63495 - Security Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_booked_with_carrier',
    description: 'FID 63495 - Shipment Booked with Carrier',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_cancellation_requested',
    description: 'Shipment Cancellation Requested',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_cancellation_requested_post_pickup',
    description: 'FID 63495 - Shipment Cancellation Requested: Post Pickup',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_cancellation_requested_pre_pickup',
    description: 'FID 63495 - Shipment Cancellation Requested: Pre Pickup',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_delay_force_majeure',
    description: 'FID 63495 - Shipment Delay: Force Majeure',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_delay_holiday',
    description: 'FID 63495 - Shipment Delay: Holiday',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_delay_in_clarification',
    description: 'FID 63495 - Shipment Delay: In Clarification',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_delay_other_reasons',
    description: 'FID 63495 - Shipment Delay: Other Reasons',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_on_time',
    description: 'FID 63495 - Shipment On Time',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_rerouted_by_carrier',
    description: 'Shipment Re-Routed by Carrier',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_rerouted_per_client_request',
    description: 'Shipment Re-Routed per Client Request',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_rolled_by_carrier',
    description: '[Ocean Planning]Carrier-Initiated Change Of Vessel / Shipment Roll',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shipment_split',
    description: 'Shipment Split',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#shortage_overage_of_cargo_received_at_origin_cfs',
    description: 'Shortage/Overage of Cargo Received at Origin CFS',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#sla_error_sla_alignment',
    description: 'SLA Error/SLA Alignment',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#sorting_error',
    description: 'FID 63495 - Sorting Error',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#special_handling_request',
    description: 'Export Special Handling Request',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#supplier_late_documents',
    description: 'Shipper Late Documents',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#supplier_late_gate_in',
    description: 'Supplier Late Gate-In',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#tendered_to_carrier',
    description: 'FID 63495 - Tendered To Carrier',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#terminal_departure_delay_other',
    description: 'Terminal Departure Delay: Other',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#transload_delay',
    description: 'Transload Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#transshipment_delay',
    description: 'Transshipment Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#trucker_rejected',
    description: 'Trucker Rejected',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#truckers_hours_expired',
    description: "Trucker's Hours Expired",
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#trucking_delay_chassis_problem',
    description: 'Trucking Delay: Chassis Problem',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#trucking_delay_mechanical_problem',
    description: 'Trucking Delay: Mechanical Problem',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#trucking_delay_other',
    description: 'Trucking Delay: Other',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#trucking_delay_port_congestion',
    description: 'Port congestion. Shipment has been delayed',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#trucking_delay_strike',
    description: 'Trucking Delay: Strike',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#trucking_delay_traffic',
    description: 'Trucking Delay: Traffic',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#unclear_mismatched_consignee_commercial_invoice_packing_list',
    description: 'Unclear/Mismatched Consignee Commercial Invoice/Packing List',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#undergoing-cpsc',
    description: 'Undergoing CPSC',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#undergoing-fda-exam',
    description: 'Undergoing FDA Exam',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#undergoing-usda',
    description: 'Undergoing USDA',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#undergoing_oga_exam',
    description: 'Undergoing OGA exam',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#unexpected_flight_cancellation_by_the_carrier',
    description: 'Unexpected Flight Cancellation by the Carrier',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#unknown_customs_hold_type',
    description: 'Unknown Customs Hold Type',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#vessel_delay_mechanical',
    description: 'Vessel Delay: Mechanical Problem',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#vessel_delay_port_congestion',
    description: 'Vessel Delay: Port Congestion',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#vessel_delay_schedule_updated_by_carrier',
    description: 'Vessel Delay: Ocean Transit Schedule Updated by Carrier',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#warehouse_devan_delay',
    description: 'Warehouse Devan Delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#warehouse_other',
    description: 'Warehouse: Other',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/shipment#weather_delay',
    description: 'Weather delay',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  //#region Invoice Events
  {
    type: '/invoice#invoice_payment_made',
    description: 'Invoice payment has been made',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/invoice#invoice_due_date_adjusted',
    description: 'Invoice payment due date has been adjusted',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/invoice#invoice_shared',
    description: 'Invoice has been shared',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/invoice#invoice_voided',
    description: 'Invoice has been voided',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/invoice#invoice_credit_applied',
    description: 'Invoice credit has been applied',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/invoice#invoice_refund_applied',
    description: 'Invoice refund has been applied',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/invoice#invoice_payment_failed',
    description: 'Invoice payment failed',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  //#region Document Events
  {
    type: '/document#document_created',
    description: 'A document has been created',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  //#region PurchaseOrder Events
  {
    type: '/purchase_order#acknowledged',
    description: 'PurchaseOrder has been acknowledged',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  },
  {
    type: '/purchase_order#updated',
    description: 'PurchaseOrder has been updated, currently only supports update through order collaboration flow',
    emails: JSON.stringify(['techteam@nethealthshops.com']),
    enableLoading: false,
    enableNotify: false
  }
]
